<template>
  <v-dialog v-model="isOpen" :width="width">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon outlined small color="info" v-bind="attrs" v-on="on"
        ><font-awesome-icon :icon="faQuestion"
      /></v-btn>
    </template>
    <v-card>
      <v-card-title v-if="title" class="text-h6">{{ title }}</v-card-title>

      <v-card-text :class="{ 'pt-5': !title }">
        <slot> Set your content into the slot </slot>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="isOpen = false">
          {{ closeBtnText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api';
import {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VDialog,
} from 'vuetify/lib';
import { faQuestion } from '@fortawesome/pro-solid-svg-icons';
import GcAlert from '@/components/primitives/GcAlert.vue';
import i18n from '@/plugins/i18n';

export default defineComponent({
  components: {
    GcAlert,
    VBtn,
    VCard,
    VCardActions,
    VCardText,
    VCardTitle,
    VDialog,
  },
  props: {
    closeBtnText: {
      default: i18n.t('close'),
      type: String,
    },
    title: {
      default: '',
      type: String,
    },
    width: {
      default: 500,
      type: Number,
    },
  },
  setup: () => {
    const isOpen = ref(false);
    return {
      faQuestion,
      isOpen,
    };
  },
});
</script>
